import React, { memo } from "react"

import { Toggle } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { bool, func } from "prop-types"

function VisibilityToggle({ isChecked = false, onChange: handleChange }) {
  return (
    <Toggle
      id="environment-settings-show-hdri"
      label="Show HDRI"
      className="environment-settings__toggle"
      isChecked={isChecked}
      onChange={event => handleChange(event.target.checked)}
    />
  )
}

VisibilityToggle.propTypes = {
  isChecked: bool,
  onChange: func.isRequired,
}

export default memo(VisibilityToggle)
